import * as React from 'react'
import { useTranslation } from 'react-i18next'
import arrow from '../../../../small_arrow.gif'

export default function NavigationList() {
  const { i18n } = useTranslation()
  const isRtl = i18n.language === 'he'  // Check if the current language is Hebrew (RTL)

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
  
    if (element) {
      // Get the header height (e.g., if your header has a fixed position)
      const headerHeight = document.querySelector('header').offsetHeight || 0;
  
      window.scrollTo({
        behavior: 'smooth',
        top: element.offsetTop - headerHeight, // Subtract header height
      });
    }
  };
  

  return (
    <ul className='index-nav-list' dir={isRtl ? 'rtl' : 'ltr'}>
      <li className='index-nav-item'>
        <a
          className='index-nav-item-link'
          href="#1"
          onClick={(e) => {
            e.preventDefault();  // Prevent default anchor behavior (page jump)
            scrollToSection('1');
          }}
        >
          <img src={arrow} alt="Arrow" />
          {i18n.t('NavigationList.index_details')}
        </a>
      </li>
      <li className='index-nav-item'>
        <a
          className='index-nav-item-link'
          href="#2"
          onClick={(e) => {
            e.preventDefault();
            scrollToSection('2');
          }}
        >
          <img src={arrow} alt="Arrow" />
          {i18n.t('NavigationList.index_composition')}
        </a>
      </li>
      <li className='index-nav-item'>
        <a
          className='index-nav-item-link'
          href="#3"
          onClick={(e) => {
            e.preventDefault();
            scrollToSection('3');
          }}
        >
          <img src={arrow} alt="Arrow" />
          {i18n.t('NavigationList.index_performance_to_date')}
        </a>
      </li>
      <li className='index-nav-item'>
        <a
          className='index-nav-item-link'
          href="#4"
          onClick={(e) => {
            e.preventDefault();
            scrollToSection('4');
          }}
        >
          <img src={arrow} alt="Arrow" />
          {i18n.t('NavigationList.theoretical_investment_of')}
        </a>
      </li>
      <li className='index-nav-item'>
        <a
          className='index-nav-item-link'
          href="#5"
          onClick={(e) => {
            e.preventDefault();
            scrollToSection('5');
          }}
        >
          <img src={arrow} alt="Arrow" />
          {i18n.t('NavigationList.risk_profile_15_years')}
        </a>
      </li>
    </ul>
  )
}
